export default "__VITE_ASSET__BUu4n26V__"